import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpService } from "./http.service";

export interface GeminiChatMessage {
	role: "user" | "model";
	text: string;
}

@Injectable({
	providedIn: "root",
})
export class GeminiChatService {
	constructor(private readonly httpService: HttpService) {}

	sendMessage(messages: GeminiChatMessage[]): Observable<{ text: string }> {
		return this.httpService.geminiChat(messages).pipe(map((response) => ({ text: response.data.text ?? "" })));
	}

	rephrase(text: string): Observable<{ text: string }> {
		return this.httpService.geminiRephrase(text).pipe(map((response) => ({ text: response.data.text ?? "" })));
	}
}
